import dayjs from "dayjs";
import moment from "moment";

export const numberInputOnWheelPreventChange = (e: any) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  e.stopPropagation();

  // Refocus immediately, on the next tick (after the current
  // function is done
  setTimeout(() => {
    e.target.focus();
  }, 0);
};

export function getErroFnc(errors: any, setState: React.Dispatch<React.SetStateAction<boolean>>) {
  const errorFind = errors.find((item: any) => item.errors.length > 0);
  errorFind ? setState(true) : setState(false);
}

export function findStore(storeList: Store[], storeId: string) {
  const chosenStore = storeList.find(store => store.id === storeId);

  if (chosenStore) {
    return chosenStore;
  } else {
    return null;
  }
}
export const formatDateTime = (dateString: string): string => {
  const date: Date = new Date(dateString);
  return moment(date).format("DD-MM-YYYY, HH:mm");
};

export const formatIndexTable = (idx: number, perPage: number, currentPage: number) => {
  return idx + 1 + perPage * (currentPage - 1);
};

/**
 * format to HH:mm:ss
 */
export const formatTime = (date: string) => {
  const originalTime = dayjs(date);
  const origin = dayjs().hour(originalTime.hour()).minute(originalTime.minute()).second(0).millisecond(0);
  return origin.format("HH:mm:ss");
};

/**
 * Check duplicate variants to show warning
 * @param attributes
 * @returns
 */
export const checkDuplicateVariantData = (attributes: SurplusProductAttribute[] | ProductAttributeValues[]) => {
  if (!attributes || attributes.length === 0)
    return { isDuplicateAttr: false, isDuplicateVariant: false, warningDes: "" };

  const attributesData = [...attributes];

  // Check duplicate attribute
  const duplicateAttr = attributesData.filter(
    (variant, index) =>
      attributesData.findIndex(x => x.attribute_name.trim() === variant.attribute_name.trim()) !== index
  );

  if (duplicateAttr.length > 0) {
    return {
      isDuplicateAttr: true,
      isDuplicateVariant: false,
      warningDes: "Attribute names cannot be duplicated. Please enter a unique name.",
    };
  }

  // Check duplicate variant
  let duplicateVariantMap: { [attribute: string]: { variant: string[] } } = {};
  attributesData.map(item => {
    if (item.variants && item.variants.length > 0 && item.attribute_name) {
      const variants: any[] = item.variants;
      // Find the duplicate attribute_value
      const duplicates = variants.filter(
        (variant: any, index: number) =>
          variants.findIndex(x => x.attribute_value.trim() === variant.attribute_value.trim()) !== index
      );

      if (duplicates.length > 0 && !duplicateVariantMap.hasOwnProperty(item.attribute_name)) {
        duplicateVariantMap[item.attribute_name] = {
          variant: duplicates.map((x: any) => x.attribute_value.trim()),
        };
      }
    }
  });

  if (Object.keys(duplicateVariantMap).length === 0)
    return { isDuplicateAttr: false, isDuplicateVariant: false, warningDes: "" };

  let text = "";

  Object.keys(duplicateVariantMap).map(key => {
    if (duplicateVariantMap[key]?.variant && duplicateVariantMap[key]?.variant.length > 0) {
      const variants = duplicateVariantMap[key].variant.filter(
        (x: string, index: number) => duplicateVariantMap[key].variant.indexOf(x) === index
      );
      variants.map(variant => {
        text += `Duplicate variant “${variant}” found in attribute “${key}”.\n`;
      });
    }
  });

  return { isDuplicateAttr: false, isDuplicateVariant: true, warningDes: text };
};
